import { z } from "zod";
import {
  asEmailAddress,
  asFormId,
  asISODateString,
  asSchoolId,
  asSubmissionId,
  parseFormElements,
  parseSubmissionData,
} from "@/src/types/domain";

export const emailAddress = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.email())
  .transform(asEmailAddress);

export const isoDateString = z
  .union([z.iso.date(), z.iso.datetime()])
  .transform(asISODateString);

export const optionalIsoDateTime = z.iso.datetime().optional();

export const formId = z
  .string()
  .regex(/^[a-z0-9]{6}$/i, "Invalid form id")
  .transform(asFormId);

export const schoolId = z.string().min(1, "Invalid school id").transform(asSchoolId);

export const submissionId = z
  .string()
  .regex(/^[0-9A-Za-z_-]{15,64}$/, "Invalid submission id")
  .transform(asSubmissionId);

export const formElements = z.unknown().transform((value, context) => {
  try {
    return parseFormElements(value);
  } catch (error) {
    context.addIssue({
      code: "custom",
      message: error instanceof Error ? error.message : "Invalid form content",
    });
    return z.NEVER;
  }
});

export const submissionData = z.unknown().transform((value, context) => {
  try {
    return parseSubmissionData(value);
  } catch (error) {
    context.addIssue({
      code: "custom",
      message: error instanceof Error ? error.message : "Invalid submission data",
    });
    return z.NEVER;
  }
});
